import Layout from "../../components/feature/Layout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ERP() {
  const navigate = useNavigate();
  const [showNewTransactionModal, setShowNewTransactionModal] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const showToast = (message: string) => {
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const financialData = [
    { label: "Total CxC", value: "$1,245,680", change: "+5.2%", icon: "ri-arrow-up-line", color: "text-[#10B981]", bgColor: "bg-[#10B981]/10" },
    { label: "Total CxP", value: "$847,320", change: "-2.1%", icon: "ri-arrow-down-line", color: "text-[#EF4444]", bgColor: "bg-[#EF4444]/10" },
    { label: "Flujo de Caja", value: "$398,360", change: "+12.5%", icon: "ri-arrow-up-line", color: "text-[#10B981]", bgColor: "bg-[#10B981]/10" },
    { label: "Saldo en Bancos", value: "$2,156,890", change: "+3.8%", icon: "ri-arrow-up-line", color: "text-[#10B981]", bgColor: "bg-[#10B981]/10" },
    { label: "Ingresos del Mes", value: "$845,200", change: "+8.4%", icon: "ri-arrow-up-line", color: "text-[#10B981]", bgColor: "bg-[#10B981]/10" },
    { label: "Egresos del Mes", value: "$612,450", change: "+4.2%", icon: "ri-arrow-up-line", color: "text-[#EAB308]", bgColor: "bg-[#EAB308]/10" },
  ];

  const recentTransactions = [
    { id: "TRX-001", type: "Ingreso", client: "Importadora del Norte", amount: "$45,280", date: "2024-01-16", status: "Completado", concept: "Pago de servicios aduanales" },
    { id: "TRX-002", type: "Egreso", client: "Proveedor Logístico", amount: "$12,500", date: "2024-01-16", status: "Completado", concept: "Pago de flete marítimo" },
    { id: "TRX-003", type: "Ingreso", client: "Exportaciones Globales", amount: "$38,900", date: "2024-01-15", status: "Pendiente", concept: "Anticipo de operación" },
    { id: "TRX-004", type: "Egreso", client: "Servicios Aduanales", amount: "$8,750", date: "2024-01-15", status: "Completado", concept: "Pago de derechos" },
    { id: "TRX-005", type: "Ingreso", client: "Comercializadora Int.", amount: "$62,150", date: "2024-01-14", status: "Completado", concept: "Liquidación de operación" },
  ];

  const quickActions = [
    { label: "Nueva Transacción", icon: "ri-add-circle-line", color: "from-[#114B7A] to-[#2F80ED]", action: () => setShowNewTransactionModal(true) },
    { label: "Nuevo Pago", icon: "ri-bank-card-line", color: "from-[#10B981] to-[#059669]", action: () => navigate('/erp/payables') },
    { label: "Nueva Factura", icon: "ri-file-text-line", color: "from-[#EAB308] to-[#D97706]", action: () => navigate('/erp/invoicing') },
    { label: "Conciliar Banco", icon: "ri-bank-line", color: "from-[#8B5CF6] to-[#7C3AED]", action: () => navigate('/erp/banks') },
  ];

  const handleCreateTransaction = () => {
    setShowNewTransactionModal(false);
    showToast('Transacción registrada exitosamente');
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Dashboard Financiero</h1>
            <p className="text-sm text-gray-500 mt-1">Visión ejecutiva de la situación financiera</p>
          </div>
          <button 
            onClick={() => setShowNewTransactionModal(true)}
            className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:opacity-90 transition-opacity whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-add-line"></i>
            Nueva Transacción
          </button>
        </div>

        {/* KPIs Financieros */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {financialData.map((item, index) => (
            <div key={index} className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)] hover:shadow-[0_8px_24px_rgba(10,42,67,0.12)] transition-shadow cursor-pointer">
              <p className="text-sm text-gray-500 mb-1">{item.label}</p>
              <p className="text-2xl font-bold text-[#0A2A43] mb-2">{item.value}</p>
              <p className={`text-xs flex items-center gap-1 ${item.color}`}>
                <i className={item.icon}></i>
                {item.change} vs mes anterior
              </p>
            </div>
          ))}
        </div>

        {/* Acciones Rápidas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {quickActions.map((action, index) => (
            <button
              key={index}
              onClick={action.action}
              className={`bg-gradient-to-r ${action.color} text-white rounded-lg p-6 hover:shadow-lg transition-all cursor-pointer whitespace-nowrap`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mb-3">
                <i className={`${action.icon} text-2xl`}></i>
              </div>
              <p className="font-semibold">{action.label}</p>
            </button>
          ))}
        </div>

        {/* Transacciones Recientes */}
        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] overflow-hidden">
          <div className="p-6 border-b border-gray-200 flex items-center justify-between">
            <h2 className="text-lg font-bold text-[#0A2A43]">Transacciones Recientes</h2>
            <button className="text-sm text-[#2F80ED] font-medium hover:underline cursor-pointer whitespace-nowrap">
              Ver todas
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#EAF2F8]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Tipo</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Cliente/Proveedor</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Concepto</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Monto</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Fecha</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-[#0A2A43] uppercase tracking-wider">Estado</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {recentTransactions.map((trx) => (
                  <tr key={trx.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 text-sm font-medium text-[#0A2A43]">{trx.id}</td>
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        trx.type === "Ingreso" ? "bg-[#10B981]/10 text-[#10B981]" : "bg-[#EF4444]/10 text-[#EF4444]"
                      }`}>
                        <i className={`${trx.type === "Ingreso" ? "ri-arrow-down-line" : "ri-arrow-up-line"} mr-1`}></i>
                        {trx.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{trx.client}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{trx.concept}</td>
                    <td className="px-6 py-4 text-sm font-semibold text-[#0A2A43]">{trx.amount}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{trx.date}</td>
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        trx.status === "Completado" ? "bg-[#10B981]/10 text-[#10B981]" : "bg-[#EAB308]/10 text-[#EAB308]"
                      }`}>
                        {trx.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Nueva Transacción */}
      {showNewTransactionModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-xl font-bold text-[#0A2A43]">Nueva Transacción</h2>
              <button onClick={() => setShowNewTransactionModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Transacción</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Ingreso</option>
                  <option>Egreso</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cliente/Proveedor</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Seleccionar...</option>
                  <option>Importadora del Norte S.A.</option>
                  <option>Exportaciones Globales</option>
                  <option>Naviera Pacific Lines</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Concepto</label>
                <input type="text" placeholder="Descripción de la transacción" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Monto</label>
                  <input type="text" placeholder="$0.00" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fecha</label>
                  <input type="date" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Cuenta Bancaria</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>BBVA México ****4521</option>
                  <option>Santander ****7832</option>
                  <option>Citibanamex ****9012</option>
                </select>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowNewTransactionModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button onClick={handleCreateTransaction} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                Registrar Transacción
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showSuccessToast && (
        <div className="fixed bottom-6 right-6 bg-[#10B981] text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 z-50">
          <i className="ri-check-circle-line text-xl"></i>
          <span className="font-medium">{toastMessage}</span>
        </div>
      )}
    </Layout>
  );
}
